'use strict';


app.factory('CheckUnauthorized', ['$q', '$location',
    function ($q, $location) {
         var service = this;

        service.responseError = function(response) {
            if (response.status == 401){
                // invalid token, logout user if he's loged in
                $location.path('/logout');
            }
            return $q.reject(response);
        };

        return service;
    }]);